export default [
  {
    label: '默认',
    name: 'default',
    theme: {
      // 默认，dark, info, primary, danger, success, warming
      headerTheme: 'info'
    }
  },
  {
    label: '黑色',
    name: 'dark',
    theme: {
      backgroundColor: '#333940',
      textColor: '#E0E0E0',
      activeTextColor: '#fff',
      headerTheme: 'dark'
    }
  },
  {
    label: '科技',
    name: 'keji',
    theme: {
      backgroundColor: '#222D32',
      textColor: '#b8c7ce',
      activeTextColor: '#fff',
      headerTheme: 'info'
    }
  },
  {
    label: '红艳',
    name: 'hongyan',
    theme: {
      backgroundColor: '#282C34',
      textColor: '#F0F0F5',
      activeTextColor: '#fff',
      headerTheme: 'danger'
    }
  },
  {
    label: '白色',
    name: 'white',
    theme: {
      backgroundColor: '#FFFFFF',
      textColor: '#303133',
      activeTextColor: '#282C34',
      headerTheme: ''
    }
  }
]



// WEBPACK FOOTER //
// ./src/views/layout/theme.js